function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  transform: "translate(0.003)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_003---Call",
  "data-name": "003---Call",
  transform: "translate(-0.003)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M7.6,9.379A6.43,6.43,0,0,1,5.654,5.728a.546.546,0,0,1,.157-.457L7.041,4.04a.549.549,0,0,0,.077-.68L5.159.318a.549.549,0,0,0-.712-.2L1.3,1.6a.546.546,0,0,0-.3.546,15.206,15.206,0,0,0,4.63,9.2,15.2,15.2,0,0,0,9.2,4.63.546.546,0,0,0,.546-.3l1.482-3.146a.549.549,0,0,0-.2-.711L13.613,9.856a.549.549,0,0,0-.68.077L11.7,11.163a.546.546,0,0,1-.457.157A6.431,6.431,0,0,1,7.6,9.379Z",
  transform: "translate(-0.997 -0.043)",
  fill: "#07abb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M33.195,15.741a.547.547,0,0,1-.547-.547,4.106,4.106,0,0,0-4.1-4.1.547.547,0,1,1,0-1.094,5.2,5.2,0,0,1,5.195,5.195A.547.547,0,0,1,33.195,15.741Z",
  transform: "translate(-20.562 -7.245)",
  fill: "#07abb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-3",
  "data-name": "Shape",
  d: "M35.929,8.475a.547.547,0,0,1-.547-.547,6.843,6.843,0,0,0-6.835-6.835.547.547,0,1,1,0-1.094,7.937,7.937,0,0,1,7.929,7.929.547.547,0,0,1-.547.547Z",
  transform: "translate(-20.541)",
  fill: "#07abb8"
})));

function SvgTel(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.934,
    height: 15.933,
    viewBox: "0 0 15.934 15.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.b8e28f21.svg";
export { ForwardRef as ReactComponent };